import React from 'react';
import ContentSection from 'components/shared/ContentSection';
import PageContainer from 'components/shared/PageContainer';
import clsx from 'clsx';
import Skeleton from 'components/shared/Skeleton';
import Button from 'components/shared/Button';
import styles from './Asset.module.scss';

function AssetSkeleton(
  { periods } :
  { periods: any },
) {
  return (
    <PageContainer className={styles.container}>
      <div className={clsx(styles.containerInner)}>
        <Skeleton
          className={styles.backLink}
          style={{ width: '40px' }}
        />
        <Skeleton
          className={styles.btnShare}
          style={{ width: '40px' }}
        />
        <Skeleton
          className={styles.catIcon}
          style={{ borderRadius: '50%' }}
        />
        <Skeleton
          className={styles.name}
          style={{ width: '80px' }}
        />
        <Skeleton
          className={styles.value}
          style={{ width: '100px' }}
        />
        <Skeleton
          className={styles.percent}
          style={{ width: '60px' }}
        />
        <div className={clsx(styles.chart, styles.chartSkeleton)} />
      </div>
      <div className={clsx(styles.containerInner)}>
        <div className={styles.graphActions}>
          <div className={styles.graphFilters}>
            {periods?.map((item: string, index: number) => (
              <div
                key={item}
                className={clsx(
                  styles.graphFilter,
                  (index === 0) && styles.graphFilterActive,
                )}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.infoHeader}>
            <div className={styles.infoHeaderLeft} />
            <div className={styles.btnGroup}>
              <Button
                className={styles.followBtn}
                wide
                skeleton
              />
              <Button
                skeleton
                className={styles.tradeBtn}
                secondary
              />
            </div>
          </div>
          <div className={styles.infoColumns}>
            <div className={styles.infoColumn}>
              <ContentSection skeleton />
            </div>
            <div className={styles.infoColumn}>
              <ContentSection skeleton />
            </div>
          </div>
          <div className={styles.infoColumns}>
            <div className={styles.infoColumn}>
              <ContentSection skeleton />
            </div>
            <div className={styles.infoColumn}>
              <ContentSection skeleton />
            </div>
          </div>
          <ContentSection skeleton />
        </div>
      </div>
    </PageContainer>
  )
}

export default AssetSkeleton
